export const colors = {
  baseBlue: '#1b6ac9',
  baseGreen: '#2da562',
  textAreaBG: '#eff2f3',
}

export const boxShadows = {
  sheet: '0 2px 5px 0 rgba(51, 51, 79, 0.07)',
}
